import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import UserAgent from 'helpers/device';

class RefreshGamesStatuses extends Component {
    onClick(e) {
        e.preventDefault();

        this.props.dispatch(Action.do('refreshGamesStatuses'));
    }

    canComponentBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isModeLateswap();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const buttonAttributes = {
            type: 'button',
            className: 'btn-text',
            ...(!UserAgent.isMobile() && {'data-tooltip-html': 'Refresh Games Statuses'}),
        };

        return (
            <button {...buttonAttributes} onClick={(e) => ::this.onClick(e)}>
                <i className="fa fa-refresh"></i>
                {UserAgent.isMobile() ? 'Refresh Games Statuses' : 'Refresh'}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

export default connect(mapStatesToProps)(RefreshGamesStatuses);
